
import React, { useState } from 'react';
import { Pencil, LogOut, ChevronRight, CheckCircle, Save } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from '../components/accueil/Navbar';
import Footer from '../components/accueil/Footer';
import ChatWidget from '../components/accueil/ChatWidget';
import PageBanner from './Banner';
import useGlobale from '../components/global';

const ProfileScreen = () => {
  const { authenticated, user, logout } = useGlobale();
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState('dossiers');
  const [formData, setFormData] = useState({
    nom: 'seydou',
    prenom: 'Boubacar',
    sexe: 'Homme',
    pieceIdentite: '',
    nationalite: 'NE',
    email: 'boubacar564@gmail.com',
    telephone1: '+22799985481',
    telephone2: '+22899985481',
    adresseNiger: 'Lome',
    adresseEtranger: 'Niamey'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsEditing(false);
    // Ajoutez ici la logique de sauvegarde
    console.log('Saving:', formData);
  };

  return (
    <>
      <Navbar authenticated={authenticated} user={user} logout={logout} />
      <PageBanner currentPage="Mon Profil" />
      
      <div className="min-h-screen bg-gray-50 py-6">
        <div className="container mx-auto px-4 mb-6">
          <nav className="flex text-gray-500 text-sm">
            <Link to="/" className="hover:text-[#287094]">Accueil</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/espace" className="hover:text-[#287094]">Mon espace</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-gray-700">Voir Profil</span>
          </nav>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Carte de profil */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col items-center mb-6">
                  {/* Avatar */}
                  <div className="w-24 h-24 bg-gray-200 rounded-full mb-4 flex items-center justify-center text-gray-400">
                    80 x 80
                  </div>
                  
                  {/* Informations principales */}
                  <div className="text-center mb-4">
                    {isEditing ? (
                      <div className="space-y-2">
                        <input
                          type="text"
                          name="prenom"
                          value={formData.prenom}
                          onChange={handleChange}
                          className="px-3 py-2 border rounded-lg w-full text-center"
                        />
                        <input
                          type="text"
                          name="nom"
                          value={formData.nom}
                          onChange={handleChange}
                          className="px-3 py-2 border rounded-lg w-full text-center"
                        />
                        <select
                          name="sexe"
                          value={formData.sexe}
                          onChange={handleChange}
                          className="px-3 py-2 border rounded-lg w-full text-center"
                        >
                          <option value="Homme">Homme</option>
                          <option value="Femme">Femme</option>
                        </select>
                      </div>
                    ) : (
                      <>
                        <h2 className="text-xl font-semibold text-gray-900">
                          {formData.prenom} {formData.nom}
                        </h2>
                        <p className="text-gray-600">{formData.sexe}</p>
                      </>
                    )}
                  </div>

                  {/* Boutons de modification */}
                  <div className="space-y-2 w-full">
                    {isEditing ? (
                      <button
                        type="submit"
                        className="flex items-center justify-center text-white bg-[#287094] hover:bg-[#1c5d7d] w-full px-4 py-2 rounded-lg"
                      >
                        <Save className="w-4 h-4 mr-2" />
                        Enregistrer les modifications
                      </button>
                    ) : (
                      <>
                        <button
                          type="button"
                          onClick={() => setIsEditing(true)}
                          className="flex items-center text-[#287094] hover:underline w-full"
                        >
                          <Pencil className="w-4 h-4 mr-2" />
                          Modifier le profil
                        </button>
                        <button
                          type="button"
                          className="flex items-center text-[#287094] hover:underline w-full"
                        >
                          <Pencil className="w-4 h-4 mr-2" />
                          Changer l'adresse de connexion
                        </button>
                      </>
                    )}
                  </div>

                  {/* Boutons d'action */}
                  <div className="grid grid-cols-2 gap-4 w-full mt-4">
                    <Link
                      to="/venir-au-niger"
                      className="px-4 py-2 border border-[#287094] text-[#287094] rounded-lg text-center hover:bg-[#287094] hover:text-white transition-colors"
                    >
                      VENIR AU NIGER
                    </Link>
                    <Link
                      to="/sortir-du-niger"
                      className="px-4 py-2 border border-[#287094] text-[#287094] rounded-lg text-center hover:bg-[#287094] hover:text-white transition-colors"
                    >
                      SORTIR DU NIGER
                    </Link>
                  </div>
                </div>

                {/* Informations détaillées */}
                <div className="space-y-4">
                  {isEditing ? (
                    <>
                      <div>
                        <label className="text-gray-700 font-medium mb-1 block">Pièce d'identité</label>
                        <input
                          type="text"
                          name="pieceIdentite"
                          value={formData.pieceIdentite}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-lg"
                          placeholder="Numéro de pièce d'identité"
                        />
                      </div>
                      
                      <div>
                        <label className="text-gray-700 font-medium mb-1 block">Nationalité</label>
                        <input
                          type="text"
                          name="nationalite"
                          value={formData.nationalite}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-lg"
                        />
                      </div>

                      <div>
                        <label className="text-gray-700 font-medium mb-1 block">E-mail</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-lg"
                        />
                      </div>

                      <div>
                        <label className="text-gray-700 font-medium mb-1 block">Téléphone</label>
                        <div className="space-y-2">
                          <input
                            type="tel"
                            name="telephone1"
                            value={formData.telephone1}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-lg"
                          />
                          <input
                            type="tel"
                            name="telephone2"
                            value={formData.telephone2}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-lg"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="text-gray-700 font-medium mb-1 block">Adresse au Niger</label>
                        <textarea
                          name="adresseNiger"
                          value={formData.adresseNiger}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-lg"
                          rows="2"
                        />
                      </div>

                      <div>
                        <label className="text-gray-700 font-medium mb-1 block">Adresse à l'étranger</label>
                        <textarea
                          name="adresseEtranger"
                          value={formData.adresseEtranger}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-lg"
                          rows="2"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <h3 className="text-gray-700 font-medium mb-1">Pièce d'identité</h3>
                        <p className="text-gray-500">{formData.pieceIdentite || 'Pas de pièce'}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-gray-700 font-medium mb-1">Nationalité</h3>
                        <p className="text-gray-500">{formData.nationalite}</p>
                      </div>

                      <div>
                        <h3 className="text-gray-700 font-medium mb-1">E-mail</h3>
                        <p className="text-gray-500">{formData.email}</p>
                      </div>

                      <div>
                        <h3 className="text-gray-700 font-medium mb-1">Téléphone</h3>
                        <p className="text-gray-500">{formData.telephone1} / {formData.telephone2}</p>
                      </div>

                      <div>
                        <h3 className="text-gray-700 font-medium mb-1">Adresse au Niger</h3>
                        <p className="text-gray-500">{formData.adresseNiger}</p>
                      </div>

                      <div>
                        <h3 className="text-gray-700 font-medium mb-1">Adresse à l'étranger</h3>
                        <p className="text-gray-500">{formData.adresseEtranger}</p>
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>

            {/* Section des dossiers */}
            <div className="md:col-span-2 bg-white rounded-xl shadow-sm p-6">
              <nav className="flex border-b border-gray-200 mb-6">
                <button 
                  onClick={() => setActiveTab('dossiers')}
                  className={`px-4 py-2 font-medium relative ${
                    activeTab === 'dossiers' 
                      ? 'text-[#287094] border-b-2 border-yellow-400' 
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Dossiers
                </button>
                <button 
                  onClick={() => setActiveTab('visa')}
                  className={`px-4 py-2 font-medium relative ${
                    activeTab === 'visa' 
                      ? 'text-[#287094] border-b-2 border-yellow-400' 
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Demandes de visa
                </button>
                <button 
                  onClick={() => setActiveTab('documents')}
                  className={`px-4 py-2 font-medium relative ${
                    activeTab === 'documents' 
                      ? 'text-[#287094] border-b-2 border-yellow-400' 
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  Documents de voyage
                </button>
              </nav>

              {/* Contenu des onglets */}
              {activeTab === 'dossiers' && (
                <>
                  <h3 className="text-lg font-medium text-gray-700 mb-4">
                    Dossiers de voyage récents liés à ce profil
                  </h3>

                  <div className="space-y-4">
                    <div className="flex items-center justify-between border-b border-gray-100 pb-4">
                      <div className="flex items-center space-x-2">
                        <CheckCircle className="w-5 h-5 text-green-500" />
                        <span className="text-[#287094] font-medium">B36GI65BH</span>
                        <span className="text-gray-500">|</span>
                        <span className="text-gray-700">Sortir du Niger</span>
                        <span className="text-gray-500">|</span>
                        <span className="text-gray-700">21/10/2024</span>
                        <span className="text-gray-500">|</span>
                        <span className="text-green-500">Completed</span>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {activeTab === 'visa' && (
                <>
                  <h3 className="text-lg font-medium text-gray-700 mb-4">
                    Demandes de visa en cours
                  </h3>
                  <div className="text-gray-500 text-center py-8">
                    Aucune demande de visa en cours
                  </div>
                </>
              )}

              {activeTab === 'documents' && (
                <>
                  <h3 className="text-lg font-medium text-gray-700 mb-4">
                    Documents de voyage
                  </h3>
                  <div className="text-gray-500 text-center py-8">
                    Aucun document de voyage disponible
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
      <ChatWidget />
    </>
  );
};

export default ProfileScreen;
